import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFire2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFire2"><Path d="M20 13.3671C20 17.8588 16.4183 21.5 12 21.5C7.58172 21.5 4 17.8588 4 13.3671C4 11.2347 5.06667 8.30556 7.2 6.19444L8.8 7.77778L12.5333 2.5C12.5333 2.5 20 6.72222 20 13.3671Z" stroke="currentColor"/><Path d="M15 18.0756C15 19.9669 13.6569 21.5 12 21.5C10.3431 21.5 9 19.9669 9 18.0756C9 15.2778 12 13.5 12 13.5C12 13.5 15 15.2778 15 18.0756Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFire2;
